module.exports = __webpack_public_path__ + "media/images/flags/64/Malawi-9dd0f9945b9f145d9ea83b0c7eee30d9.png";